import { Reveal } from "./Reveal";
import { IMAGES } from "../constants/site";

const SHOTS = [
  { src: IMAGES.elevation, caption: "The Tower — Reference Elevation", span: "md:row-span-2" },
  { src: IMAGES.elevTop, caption: "Crown Detail", span: "" },
  { src: IMAGES.elevMid, caption: "Glass & Sky", span: "" },
  { src: IMAGES.conference, caption: "Conference Suites", span: "md:row-span-2" },
  { src: IMAGES.masterplan, caption: "Master Plan — Indicative", span: "" },
  { src: IMAGES.elevDuo, caption: "Dusk Study", span: "" },
];

export default function Gallery() {
  return (
    <section id="gallery" data-testid="gallery-section" className="py-24 md:py-32 border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6">
        <Reveal>
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">Gallery</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight mb-14">
            The district, <span className="italic text-primary">in frame</span>
          </h2>
        </Reveal>
        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[260px] gap-4">
          {SHOTS.map((s, i) => (
            <Reveal key={s.caption} delay={(i % 3) * 0.08} className={s.span}>
              <div
                data-testid={`gallery-item-${i}`}
                className="group relative h-full w-full overflow-hidden border border-border"
              >
                <img
                  src={s.src}
                  alt={s.caption}
                  className="w-full h-full object-cover group-hover:scale-105 group-hover:rotate-[1.2deg] transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-black/30 opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                <p className="absolute bottom-5 left-5 font-display text-xl text-white opacity-0 translate-y-2 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-500">
                  {s.caption}
                </p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="text-[11px] text-muted-foreground/70 mt-6">*Images are artistic representations for illustration only.</p>
      </div>
    </section>
  );
}
